<template>
  <layout>
    <div slot="content">
      <i-card title="对账单">
        <div slot="content">
          <div>
            <el-form :inline="true" size="small" style="text-align: right">
              <el-form-item>
                <el-input v-model="filter.trade_code" placeholder="订单号" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-cascader
                  style="width: 230px"
                  filterable
                  clearable
                  size="small"
                  placeholder="请选择票券"
                  :show-all-levels="false"
                  v-model="filter.sku_id_info"
                  :options="skuOptions.sku_list"
                  :props="{ expandTrigger: 'hover' }"
                  @change="getSku"
                ></el-cascader>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="filter.date"
                  clearable
                  type="daterange"
                  align="right"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="getDate"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-select v-model="filter.checked" placeholder="对账状态" style="width: 120px">
                  <el-option label="已对账" value="1"></el-option>
                  <el-option label="未对账" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getList">查找</el-button>
                <el-button type="primary" @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <el-descriptions title="对账汇总" direction="vertical" :column="4" border style="margin-bottom: 10px">
            <el-descriptions-item label="已核销">{{ pageInfo.total }}张</el-descriptions-item>
            <el-descriptions-item label="已对账">{{ pageInfo.total }}张</el-descriptions-item>
          </el-descriptions>
          <div style="margin-bottom: 10px;text-align: right">
            <el-button type="primary" size="mini" :disabled="selectedRowIds ===''" @click="showCheckConfirm">一键对账</el-button>
          </div>
          <el-table :data="cateList" @selection-change="getSelectedOrder" :border="true">
            <el-table-column type="selection" :selectable="canSelect" width="40"></el-table-column>
            <el-table-column prop="trade_code" label="订单号" width="200px"></el-table-column>
            <el-table-column prop="title" label="票券名称" width="250px"></el-table-column>
            <el-table-column prop="check_status_name" label="使用状态" width="100"></el-table-column>
            <el-table-column prop="checked_name" label="对账状态" width="100">
              <template slot-scope="scope">
                <el-tag size="mini" type="success" v-if="scope.row.checked === 1">已对账</el-tag>
                <el-tag size="mini" type="danger" v-else>未对账</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="real_name" label="游客姓名" width="100"></el-table-column>
            <el-table-column prop="cert_no" label="证件号码" width="180"></el-table-column>
            <el-table-column prop="ticket_code" label="外代票券码" width="100"></el-table-column>
            <el-table-column prop="date" label="结算日期" width="100"></el-table-column>
            <el-table-column prop="created_at" label="使用时间" width="200"></el-table-column>
          </el-table>
          <div class="page-wrap">
            <el-pagination background :page-size="pageInfo.per_page" :current-page="pageInfo.current_page"
                           layout="prev, pager, next"
                           @current-change="changePage" :total="pageInfo.total"/>
          </div>
        </div>
      </i-card>
    </div>
  </layout>
</template>

<script>
export default {
  name: "cate",
  data() {
    return {
      cateList: [],
      showStockDialog: false,
      loadingStock: false,
      stockList: [],
      currSku: {},
      skuOptions: {
        sku_list: []
      },
      filter: {
        trade_code: '',
        date: [],
        start_date: '',
        end_date: '',
        sku_id_info: [],
        sku_id: "",
        checked: ""
      },
      selectedRowIds: "",
      loading: false,
      pageInfo: {
        current_page: 1,
        total: 0,
        per_page: 20
      },
    }
  },
  methods: {
    getList: function () {
      this.$http.request('reconciliation', {page: this.pageInfo.current_page, filter: this.filter}).then(res => {
        this.cateList = res.data;
        this.loading = false;
        this.pageInfo = res.meta;
      });
    },
    getDate: function (date) {
      if (date == null) {
        this.filter.start_date = this.filter.end_date = '';
      } else {
        this.filter.start_date = date[0];
        this.filter.end_date = date[1];
      }
    },
    getOptions: function () {
      this.$http.request('skuOptions').then(res => {
        this.skuOptions = res.data;
      })
    },
    changePage: function (page) {
      this.pageInfo.current_page = page;
      this.getList();
      window.scrollTo(0, 0)
    },
    getSku: function (sku) {
      this.filter.sku_id = sku[1];
    },
    initDate: function () {
      let date = new Date();
      let today = date.getFullYear() + '-' + this.formatDate(date.getMonth() + 1) + "-" + this.formatDate(date.getDate());
      this.filter.date = [today, today];
      this.filter.start_date = this.filter.end_date = today;
    },
    canSelect: function (row, index) {
      return row.checked === 0;
    },
    getSelectedOrder: function (selectedRows) {
      this.selectedRowIds = '';
      selectedRows.forEach(row => {
        this.selectedRowIds += row.id + ',';
      });
    },
    showCheckConfirm: function () {
      this.$confirm('您确定要完成对账吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doCheck();
      })
    },
    doCheck: function () {
      this.$http.request('batchChecked', {ids: this.selectedRowIds}).then(res => {
        if (res.status === 'success') {
          this.$message({
            message: res.message,
            type: 'success',
            onClose: () => {
              this.getList();
            }
          });
        }
      })
    },
    formatDate: function (num) {
      if (num < 10) {
        num = '0' + num;
      }
      return num;
    },
    reset: function () {
      for (let i in this.filter) {
        if (i !== 'goods_type') {
          this.filter[i] = '';
        }
      }
      this.getOrder();
    },
  },
  created: function () {
    this.getOptions();
    this.initDate();
    this.getList();
  }
}
</script>

<style scoped lang="less">
.curr-sku {
  padding-bottom: 20px;
  font-size: 14px;
  font-weight: bold;
}

.num {
  padding: 10px 0;
  margin-bottom: 15px;
  color: #f83d3d;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/settings/night_ship/reconciliation_list.vue